import { useNavigate } from "react-router-dom";
import { EXERCISE_LIBRARY_VERSION, RULES_VERSION } from "@jilian/shared";
import { Card, RiskTag, SectionTitle } from "../../components/ui";

export function SettingsAbout() {
  const nav = useNavigate();

  return (
    <div className="min-h-screen mx-auto max-w-[480px] px-4 pt-safe-top pb-10 space-y-4">
      {/* 顶部返回导航栏 */}
      <div className="flex items-center justify-between py-3 mb-2">
        <button
          onClick={() => nav(-1)}
          className="inline-flex items-center gap-1 text-tone-accent font-semibold text-sm active:opacity-70"
        >
          <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2.2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
          </svg>
          返回
        </button>
        <h1 className="text-[17px] font-bold text-tone-ink">关于与声明</h1>
        <div className="w-12" />
      </div>

      {/* 安装说明 */}
      <SectionTitle>添加到手机主屏幕（离线 PWA）</SectionTitle>
      <Card className="p-4 text-[12px] text-tone-soft leading-relaxed space-y-2 border border-tone-border shadow-sm">
        <p>
          <strong className="text-tone-ink">iPhone / iPad（Safari）</strong>：分享按钮 → 「添加到主屏幕」→ 从主屏幕图标打开（PWA 安装态下通知/离线能力最完整）。
        </p>
        <p>
          <strong className="text-tone-ink">Android（Chrome）</strong>：菜单 → 「安装应用」或地址栏安装提示。
        </p>
        <p>
          未安装也可在浏览器使用；核心训练流程离线可用，首次登录与首次设备初始化需联网。PWA 安装验证需要 HTTPS 域名（本地 dev 仅限开发）。
        </p>
      </Card>

      {/* 平台声明 */}
      <SectionTitle>平台能力说明</SectionTitle>
      <Card className="p-4 space-y-2 text-[12px] text-tone-soft leading-relaxed border border-tone-border shadow-sm">
        <p>· 核心训练流程支持离线；首次登录需联网。</p>
        <p>· iPhone 后台通知、屏幕常亮、后台计时不可靠，按绝对时间重算并降级为页面内提示；不承诺媲美原生闹钟。</p>
        <p>· 触觉反馈为渐进增强；不支持时用短暂缩放/高亮替代；不声称所有 iPhone PWA 都能调用原生 Taptic。</p>
      </Card>

      {/* 医疗边界 */}
      <SectionTitle>隐私与医疗边界</SectionTitle>
      <Card className="p-4 border border-tone-border shadow-sm">
        <RiskTag tone="danger">重要说明</RiskTag>
        <p className="text-[13px] text-tone-ink leading-relaxed mt-2">
          本工具是记录 + 动作筛选辅助工具，<strong>不是诊断工具</strong>：不判断骨折是否愈合、不决定何时恢复前足承重、
          不以训练时无痛替代复诊结论、不生成未经动作库审核的康复处方、不替代医生/康复师/物理治疗师。
        </p>
        <p className="text-[12px] text-tone-soft mt-2 leading-relaxed">
          训练生成/进阶/伤情判定只能由确定性规则引擎承担，零 LLM 介入训练安全。AI 只负责理解与表达（饮食估算/纠错/解释）。
        </p>
      </Card>

      {/* 版本 */}
      <Card className="p-4 text-[12px] text-tone-soft space-y-1 border border-tone-border shadow-sm">
        <div className="font-semibold text-tone-ink">极练 Rehab & Fit · 阶段 8（自定义序列 / 独立动作库 / 极简导航）</div>
        <div>应用版本 v0.2.0 · 规则引擎 {RULES_VERSION} · 动作库 {EXERCISE_LIBRARY_VERSION}</div>
      </Card>
    </div>
  );
}
